import React from 'react'
import PropTypes from 'prop-types'
import {
    List,
    TextareaItem,
    Button,
    InputItem,
    NavBar,
    Checkbox,
    Icon,
    WhiteSpace,
    Picker,
    Toast,
    DatePicker,
    WingBlank
} from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css'
import {Link} from 'react-router-dom'
import {createForm} from 'rc-form'
import {postRequest} from '../../../utils/utils'
import './index.css'
import moment from 'moment'
import CustomerSearch from '../../components/customer_search'
import AmapSearch from '../../components/amapSearch'

const Item = List.Item;


class QingJiaDelEditor extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        saveQingJiaDel: PropTypes.func.isRequired,
    }

    state = {
        content: '',
        qingjia_id: '',
        qingjiadel_id: '',
    };

    // componentWillMount() {
    //     const waichuback_id = localStorage.getItem('waichuback_id');
    //     this.setState({waichuback_id: waichuback_id});
    //     if (waichuback_id !== '')//判断是编辑还是新增
    //     {
    //         this.getDetail(waichu_id);
    //     }
    // }

    componentDidMount() {
    }

    onSubmit = () => {
        const {validateFields} = this.props.form
        const {content} = this.state
        const {files, history, saveQingJiaDel} = this.props
        const qingjia_id = localStorage.getItem('qingjia_id');
        validateFields((err, values) => {
            let body = '';
            if (content) {
                body += `content=${content}`
            } else {
                Toast.info('撤销请假原由必填！', 1);
                return
            }
            if (!err) {
                body += `&id=${qingjia_id}`
                //console.log(body);
                saveQingJiaDel(body, history)
            }
        });
    }

    render() {
        const {getFieldProps} = this.props.form;
        const {ctype, detail} = this.props;

        return (
            <div className='index-content' id='wipeout_editor'>
                <NavBar
                    mode="dark"
                    icon={<Icon type="left"/>}
                    onLeftClick={() => this.props.history.goBack()}
                >撤销请假申请</NavBar>
                <List renderHeader='' className="qj-list my_list">

                    <TextareaItem
                        {...getFieldProps('content', {
                            rules: [{require: true}],
                        })}
                        value={this.state.content}
                        onChange={value => this.setState({content: value})}
                        placeholder="请填写撤销请假原由"
                        data-seed="logId"
                        rows={4}
                        ref={el => this.customFocusInst = el}
                    />
                </List>
                <WhiteSpace/>
                <WhiteSpace/>
                <WhiteSpace/>
                <WingBlank size="md">
                    <Button type='primary' onClick={() => this.onSubmit()}>提交</Button>
                </WingBlank>

            </div>
        )
    }
}

export default createForm()(QingJiaDelEditor)